import TRC_FILE_TYPE from '@/TRC/constants/trcFileType';
import TRCPageLikeCard from '../../../components/pageLikeCard';
import TRC_PAGE_CATEGORIES from '@/TRC/constants/trcCategories';
import VideoThumbnailCard from '@/v2/components/VideoThumbnailCard';
import TRC_CONTENT from '@/constants/trcContentType';
import { TRC_ROUTES } from '@/TRC/constants/trcRoutes';


const LessonGrid = ({ contents, basePath }) => {
	return (
		<div className="c-video_list">
			<div className="row m-0">
				{contents?.map(content => (
					<div key={content._id || content?.title} className="mb-2">
							<VideoThumbnailCard
								content={content}
								route={TRC_ROUTES.LESSON_PLANS.toLowerCase()}
								basePath={basePath}
								showSaveButton={false}
								showAddToPlaylist={false}
								type={TRC_CONTENT.TRC}
								customStyles={{ width: '100%', aspectRatio: '16/9' }}
							/>
					</div>
				))}
			</div>
		</div>
	);
};


export default LessonGrid;
